module.exports = __webpack_public_path__ + "static/media/pic5.9ff415eb.jpg";